// src/services/Profile/CustomerAPI.js

const API_BASE = process.env.REACT_APP_API_URL || 'https://online-tech.in/api/';

/* ================= FETCH CUSTOMER ================= */
export const fetchCustomerById = async (id) => {
  try {
    const response = await fetch(
      `${API_BASE}MasterAPI/GetCustomersById?id=${id}`
    );

    const text = await response.text();
    const result = JSON.parse(text);

    console.log("📦 FETCH CUSTOMER:", result);

    if (!response.ok) {
      throw new Error(result?.message || "Fetch failed");
    }

    return result?.data || result;
  } catch (error) {
    console.error("❌ fetchCustomerById Error:", error);
    throw error;
  }
};

/* ================= UPDATE CUSTOMER ================= */
export const updateCustomer = async (formData) => {
  try {
    const fd = new FormData();

    fd.append("Id", formData.get("Id") || "");
    fd.append("CustomerName", formData.get("CustomerName") || "");
    fd.append("EmailId", formData.get("EmailId") || "");
    fd.append("PhoneNumber", formData.get("PhoneNumber") || "");

    // 🔥 FIX DOB FORMAT
    const dob = formData.get("DOB");
    fd.append(
      "DOB",
      dob ? new Date(dob).toISOString() : ""
    );

    fd.append("BloodGroup", Number(formData.get("BloodGroup") || 0));
    fd.append("Gender", Number(formData.get("Gender") || 0));

    const photo = formData.get("UploadPhoto");
    if (photo) {
      fd.append("UploadPhoto", photo);
    }

    console.log("🚀 FINAL FORM DATA:");
    for (let p of fd.entries()) {
      console.log(p[0], p[1]);
    }

    const res = await fetch(`${API_BASE}MasterAPI/UpdateCustomer`, {
      method: "POST",
      body: fd,
    });

    const data = await res.json();

    console.log("📦 RESPONSE:", data);

    if (!res.ok) {
      throw new Error(data?.message || "Update failed");
    }

    return data;
  } catch (err) {
    console.error("❌ updateCustomer Error:", err);
    throw err;
  }
};

/* ================= BLOOD GROUPS ================= */
export const fetchBloodGroups = async () => {
  try {
    const res = await fetch(
      `${API_BASE}MasterAPI/GetBloodGroups`
    );

    const text = await res.text();
    const result = JSON.parse(text);

    return Array.isArray(result) ? result : result?.data || [];
  } catch (err) {
    console.error(err);
    return [];
  }
};